module.exports = __webpack_public_path__ + "media/pricing/COVID_19_CDC_Guidelines-d29ce93b.pdf";